<template>
    <img class="main-image" :src="vimeoThumb" v-if="vimeoData !== undefined && vimeoData !== null"  :alt="vimeoData.title" @click="videoModal"/>
</template>

<script>
import { linkTo } from '@/assets/mixins/mixins';

const axios = require('axios');

export default {
    name: 'VideoTile',
    mixins: [linkTo],
    props: {
        schemeDoc: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            vimeoData: null,
        };
    },
    created () {
        // Make a request for a user with a given ID
        //
        let authSet = '';
        if (axios.defaults.headers.common.Authorization) {
            authSet = axios.defaults.headers.common.Authorization;
            axios.defaults.headers.common = {};
        }
        if (axios.defaults.headers.get.ImpersonateId) {
            axios.defaults.headers.get = {};
        }
        axios({
            method: 'get', // you can set what request you want to be
            url: `https://vimeo.com/api/oembed.json?url=${this.schemeDoc.videoUrl}&width=750`,
            headers: {
            },
        })
            .then((response) => {
                // handle success
                this.vimeoData = response.data;
                setTimeout(() => {
                    this.$redrawVueMasonry('key-information');
                }, 100);
            });
        if (authSet !== '') {
            axios.defaults.headers.common.Authorization = authSet;
        }
    },
    computed: {
        vimeoThumb () {
            if (this.vimeoData !== null) {
                return this.vimeoData.thumbnail_url_with_play_button;
            }
            return `${this.$store.state.clientConfig.directoryUrl}/img/${this.schemeDoc.imageUrl}`;
        },
    },
    methods: {
        videoModal () {
            this.$emit('videoModal', this.vimeoData.html);
        },
    },
};
</script>

<style lang="scss" scoped>
.main-image{
    width: 100%;
    cursor: pointer;
}
</style>
